function NoResultsAlert(props) {
    return(
        <span className="
        absolute top-0 left-0 right-0 text-[12px] text-center mt-[12px]
        lg:static lg:inline lg:mr-[24px] font-bold lg:text[15px] text-[#F74646] leading-[1.48]"
        >
            No Results
        </span>
    );
}

export default NoResultsAlert;